document.addEventListener('turbolinks:load', function() {
  // Load YouTube API script if not already loaded
  if (!window.YT) {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  let player = null;

  // Handle both YouTube and native video end events
  function handleVideoEnd() {
    const urlParams = new URLSearchParams(window.location.search);
    const playlistId = urlParams.get('playlist');
    const userPlaylistId = urlParams.get('user_playlist_id');
    const currentPostId = window.location.pathname.split('/').pop();

    // First check if we have a post ID
    if (!currentPostId) return;

    // First, try to get the current playlist info
    fetch(`/posts/${currentPostId}/playlist_info`, {
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(playlistInfo => {
      const params = new URLSearchParams();
      params.append('current_post_id', currentPostId);

      let fetchUrl;
      if (userPlaylistId) {
        params.append('user_playlist_id', userPlaylistId);
        fetchUrl = `/playlists/${userPlaylistId}/next_post`;
      } else if (playlistId) {
        fetchUrl = `/playlists/${playlistId}/next_post`;
      } else if (playlistInfo && playlistInfo.playlist_id) {
        fetchUrl = `/playlists/${playlistInfo.playlist_id}/next_post`;
      } else {
        console.log('No playlist found for this post');
        return;
      }

      // Fetch the next video in the playlist
      return fetch(`${fetchUrl}?${params.toString()}`, {
      headers: {
        'Accept': 'application/json'
      }
      })
      .then(response => response.json())
      .then(data => {
        if (data.next_post_url) {
          // Add auto_play parameter to the next post URL
          const nextUrl = new URL(data.next_post_url, window.location.origin);
          nextUrl.searchParams.set('auto_play', 'true');
          window.location.href = nextUrl.toString();
        }
      })
      .catch(error => console.error('Error fetching next video:', error));
    })
    .catch(error => console.error('Error fetching playlist info:', error));
  }

  function extractYouTubeId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  }

  function onPlayerStateChange(event) {
    // YT.PlayerState.ENDED = 0
    if (event.data === 0) {
      handleVideoEnd();
    }
  }

  function initYouTubePlayer() {
    const videoWrapper = document.querySelector('.video-wrapper');
    if (!videoWrapper) return;

    const videoUrl = videoWrapper.dataset.videoUrl;
    if (!videoUrl || !videoUrl.includes('youtu')) return;

    const videoId = extractYouTubeId(videoUrl);
    if (!videoId) return;

    // Check URL parameters for autoplay
    const urlParams = new URLSearchParams(window.location.search);
    const shouldAutoplay = urlParams.get('auto_play') === 'true';
    
    player = new YT.Player('video-player', {
      height: '100%',
      width: '100%',
      videoId: videoId,
      playerVars: {
        modestbranding: 1,
        playsinline: 1,
        // Start muted for autoplay
        mute: shouldAutoplay ? 1 : 0,
        rel: 0,
        autoplay: shouldAutoplay ? 1 : 0,
        mute: shouldAutoplay ? 1 : 0  // YouTube requires muting for autoplay to work
      },
      events: {
        onStateChange: onPlayerStateChange,
        onReady: (event) => {
          if (shouldAutoplay) {
            event.target.playVideo();
            // Unmute after a short delay
            setTimeout(() => {
              event.target.unMute();
            }, 500);
          }
        }
      }
    });
  }

  // Initialize video player
  const video = document.querySelector('video');
  const videoWrapper = document.querySelector('.video-wrapper');
  const urlParams = new URLSearchParams(window.location.search);
  const shouldAutoplay = urlParams.get('auto_play') === 'true';

  if (video) {
    // Initialize HLS.js for HLS streams in browsers that don't support HLS natively
    if (video.dataset.hls === 'true' && typeof Hls !== 'undefined' && Hls.isSupported()) {
      const source = video.querySelector('source');
      if (source) {
        const hls = new Hls();
        hls.loadSource(source.src);
        hls.attachMedia(video);
      }
    }
    video.addEventListener('ended', handleVideoEnd);
    if (shouldAutoplay) {
      // Try to play and handle any autoplay restrictions
      // Try playing unmuted first
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(e => {
          // If autoplay fails, try muting first (browser policy)
          video.muted = true;
          return video.play().then(() => {
            // Once playing starts, wait a moment and unmute
            setTimeout(() => {
              video.muted = false;
            }, 500);
          });
        })
        .catch(e => console.error('Autoplay failed:', e));
      }
    }
  } else {
    // If no native video player, try initializing YouTube player
    if (window.YT) {
      initYouTubePlayer();
    } else {
      window.onYouTubeIframeAPIReady = initYouTubePlayer;
    }
  }
});
